import SimpleVideoPlayer from '@/src/shared/components/SimpleVideoPlayer';

export const Video = () => {
  return (
    <SimpleVideoPlayer
      src="/videos/cotent-calendar-landing.mp4"
      autoPlay
      muted
      loop
      playsInline
      disablePictureInPicture
      disableContextMenu
      preload="metadata"
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};
